import React, {createContext, useContext, useEffect, useState} from "react";

const TokenContext = createContext(null);

export const TokenProvider = ({children}) => {
    const [token, setToken] = useState(() => {
        const storedToken = localStorage.getItem('token');
        try{
            return storedToken ? JSON.parse(storedToken) : null
        } catch (error) {
            return null;
        }
    });

    useEffect(() => {
        if (token === false || token == null){
            localStorage.removeItem('token');
        }else{
          localStorage.setItem('token', JSON.stringify(token))
        }
    }, [token]);

    return (
        <TokenContext.Provider value={[token, setToken]}>
            {children}
        </TokenContext.Provider>
    );
};

export const useToken = () => useContext(TokenContext);
